import { IPersonnelGroup } from "@/customTypings/PersonnelGroup";
import { faPen, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import HHTModal from "../Shared/HHTModal";
import {
    ColumnRender, FilterType, IColumn, IFilter, IPagedListAction
} from "./PagedList/Declarations";
import { PagedList } from "./PagedList/PagedList";
import { personnelGroupService } from "../services/personnelgroup.service";
import { EditPersonnelGroupModel } from "./Models/EditPersonnelGroupModel";
function AddPersonnelGroup() {
    const [showAddTask, setShowAddTask] = useState(false);
    const [refreshNumber, setRefeshNumber] = useState(0);
    const [showEditPersonnel, setShowEditPersonnel] = useState(false);
    const [personnelGroup, setPersonnelGroup] = useState<IPersonnelGroup>();
    const columns: IColumn[] = [];
    const filters: IFilter[] = [];
    const headActions: IPagedListAction[] = [];
    const handleAddTask = (added: boolean) => {
        if (added) {
            setRefeshNumber(refreshNumber + 1);
        }
        setShowAddTask(false);
    };
    const handleEditPersonnel = (added: boolean) => {
        setShowEditPersonnel(false);
    };
    const handleOpenAddTask = () => {
        setShowAddTask(true);
    };
    columns.push({
        member: "name",
        renderAs: ColumnRender.text,
        title: "Group name",
        width: 100,
    } as IColumn);

    filters.push({
        title: "Group name",
        member: "name",
        type: FilterType.text,
    } as IFilter);

    headActions.push({
        icon: faPlus,
        text: "Add Personnel Group",
        onClick: handleOpenAddTask,
    } as IPagedListAction);

    const addPersonnelGroup = async (values: any) => {
        const personnelGroup: IPersonnelGroup = {
            id: undefined,
            name: values.name,
        };

        try {
            const res = await personnelGroupService.addPersonnelGroup(personnelGroup);
            return res;
        } catch (error: any) {
            return { status: "Failure", message: error.title };
        }
    };

    return (
        <>
            <Container fluid>
                <Helmet>
                    <title>Personnel Groups</title>
                </Helmet>
                <Row>
                    <Col>
                        <h1 className="my-3">Personnel Group</h1>
                        <PagedList
                            itemActions={[
                                {
                                    icon: faPen,
                                    text: "Edit",
                                    onClick: (item) => {
                                        setPersonnelGroup(item);
                                        setShowEditPersonnel(true);
                                    },
                                } as IPagedListAction,
                            ]}
                            columns={columns}
                            headActions={headActions}
                            filters={filters}
                            defaultSortBy="name"
                            getUrl="api/personnelgroup/all"
                            avatarUrl="api/avatar"
                            rowFormatter={(item: any) => {
                                return null;
                            }}
                            refreshNumber={refreshNumber}
                        />
                        <HHTModal
                            callback={addPersonnelGroup}
                            show={showAddTask}
                            onClose={handleAddTask}
                            title="Personnel Group"
                            fields={[{ name: "name", type: "text" }]}
                        />
                    </Col>
                </Row>
            </Container>
            <EditPersonnelGroupModel customerId={null} show={showEditPersonnel} onClose={handleEditPersonnel} groupId={personnelGroup?.id} />
        </>
    );
}

export default AddPersonnelGroup;
